import BRANDS_ENUM from '@/enums/brands.enum.js'
import REQUIRED_FIELDS_ENUM from '@/enums/required-fields.enum.js'
import TextManager from '@/utils/text-manager.utils'

export const ACCEPTED_BRANDS_LIST = [
  BRANDS_ENUM.VISA,
  BRANDS_ENUM.MASTERCARD,
  BRANDS_ENUM.HIPERCARD,
  BRANDS_ENUM.DISCOVER,
  BRANDS_ENUM.DINERS,
  BRANDS_ENUM.AMEX,
  BRANDS_ENUM.ELO,
  BRANDS_ENUM.JCB,
  BRANDS_ENUM.CREDZ,
  BRANDS_ENUM.SENFF,
  BRANDS_ENUM.CABAL,
  BRANDS_ENUM.SOROCRED,
  BRANDS_ENUM.BANESCARD
].map(brand => {
  return {
    key: brand,
    label: TextManager.toCapitalize(brand),
    id: brand,
    name: brand,
    value: false
  }
})

export const REQUIRED_FIELDS_LIST = [
  REQUIRED_FIELDS_ENUM.EMAIL,
  REQUIRED_FIELDS_ENUM.DOCUMENT,
  REQUIRED_FIELDS_ENUM.HOME_PHONE,
  REQUIRED_FIELDS_ENUM.MOBILE_PHONE,
  REQUIRED_FIELDS_ENUM.ADDRESS
].map(field => {
  const prefixLabel = field === 'address'
  const BILLING_FIELD = `billing.${field}`
  const CUSTOMER_FIELD = `customer.${field}`
  return {
    key: prefixLabel ? BILLING_FIELD : CUSTOMER_FIELD,
    label: prefixLabel
      ? 'account.settings.checkout.billing_' + field
      : 'account.settings.checkout.' + field,
    id: prefixLabel ? BILLING_FIELD : CUSTOMER_FIELD,
    name: prefixLabel ? BILLING_FIELD : CUSTOMER_FIELD,
    value: false
  }
})
